export default class Message
{

	static TYPE_INFO = 1;
	static TYPE_WARNING = 2;
	static TYPE_VALIDATION = 3;
	static TYPE_ERROR = 4;

	constructor(type, code, message) {
		this.type = type;
		this.code = code;
		this.message = message;
	}

	getAlertClass() {
		return {
			[Message.TYPE_INFO]: 'alert-info',
			[Message.TYPE_WARNING]: 'alert-warning',
			[Message.TYPE_VALIDATION]: 'alert-danger',
			[Message.TYPE_ERROR]: 'alert-danger'
		}[this.type];
	}
}



// WEBPACK FOOTER //
// ./React/src/enums/Message.js